import { EducatorPageChrome } from "@/pages/educators/page-chrome"

import { CardContent } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"

import { DataDrivenSpecialityForm } from "./data-driven-form"
import { useDataDrivenNewProps } from "./page-props"

export default function NewDataDriven() {
  const { speciality, personal_listing_profile_id } = useDataDrivenNewProps()

  return (
    <>
      <EducatorPageChrome />
      <PageBody>
        <CardContent>
          <DataDrivenSpecialityForm
            form={speciality}
            listingProfileId={personal_listing_profile_id}
          />
        </CardContent>
      </PageBody>
    </>
  )
}
